import { toast } from 'react-hot-toast';

const getToastPosition = () => {
	try {
		// Check if we're in a browser environment and can access localStorage
		if (typeof window !== 'undefined' && window.localStorage) {
			const token = localStorage.getItem('authToken');
			return token ? 'top-right' : 'top-left';
		}
		return 'top-left';
	} catch (error) {
		return 'top-left'; 
	}
};

// Centralized toast helpers with sensible defaults
export const Toast = {
	// Basic types
	success: (message, opts = {}) =>
		toast.success(message, {
			position: getToastPosition(),
			style: {
				background: '#333',
				color: '#fff',
				fontWeight: 'bold'
			},
			...opts
		}),
	error: (message, opts = {}) =>
		toast.error(message, {
			position: getToastPosition(),
			style: {
				background: '#333',
				color: '#fff',
				fontWeight: 'bold'
			},
			...opts
		}),
	info: (message, opts = {}) =>
		toast(message, {
			position: getToastPosition(),
			style: {
				background: '#333',
				color: '#fff',
				fontWeight: 'bold'
			},
			...opts
		}),

	// Promise-based toasts
	promise: (promise, messages, opts = {}) =>
		toast.promise(promise, messages, { position: getToastPosition(), ...opts }),

	// Custom content
	custom: (renderer, opts = {}) => toast.custom(renderer, { position: getToastPosition(), ...opts }),

	// Control
	dismiss: (id) => toast.dismiss(id),
	remove: (id) => toast.remove(id),

	// Expose raw for advanced usage
	raw: toast
};

